import { getOcapiV1 } from './api/v1/get-ocapi-v1';
import { getHttpClient } from './utils/get-http-client';
/**
 * Creates an [[OcapiClient]] instance based on the provided configuration options.
 *
 * @param config The configuration options.
 * @returns The created [[OcapiClient]] instance.
 */
export const createOcapiClient = (config) => {
    const httpClient = getHttpClient(Object.assign(Object.assign({}, config), { baseUrl: config.url }));
    return {
        v1: getOcapiV1({ httpClient })
    };
};
//# sourceMappingURL=create-ocapi-client.js.map